module.exports = __webpack_public_path__ + "static/media/Printer.8d0d078a.svg";